export const ENDPOINTS = {
  USER: {
    PROFILE: '/user/staff/profile',
    SETTINGS: '/user-settings',
  },
};
